import React from 'react'
import { SectionWrapper } from './SectionWrapper'
import { DocumentsList } from '../../../common/DocumentsList'

const SummaryDocuments = ({data, title}) => {
    return !!data?.length && (
        <SectionWrapper id="summary-documents" title={title}>
            <DocumentsList
                wrap={true}
                data={data}
                keyToPrint={'type'}
            />
        </SectionWrapper>
    )
}

export { SummaryDocuments }